'use client';

import React, { useMemo } from 'react';
import type { SelectionGiftPromptProps } from '../available-cart-level-gifts.types';
import styles from '../available-cart-level-gifts.module.css';
import { Text } from '../../../../../utils';
import { CallToAction, getColorVar } from '@kidslabs/mario-nextjs-react-ui-core';
import { ChevronRight } from 'lucide-react';

/**
 * SelectionGiftPrompt - Prompt button to open gift selection
 * Matches mobile implementation using CallToAction component
 */
export const SelectionGiftPrompt: React.FC<SelectionGiftPromptProps> = ({ icon, text, onPress, isMobile }) => {
    const trailingAction = useMemo(
        () =>
            isMobile === false ? (
                <div className={styles.trailingAction}>
                    <Text className={styles.trailingActionText}>Chọn quà</Text>
                    <ChevronRight className={styles.trailingActionIcon} />
                </div>
            ) : null,
        [isMobile]
    );

    return (
        <div className={styles.promptCard}>
            <CallToAction
                textId="call-to-action-gift-checkout"
                imageIcon={icon}
                eventCallBack={onPress}
                fontColor={getColorVar('primary', '100')}
                backgroundColor={getColorVar('softAccent', '25')}
                paddingHorizontal={16}
                paddingVertical={16}
                iconSize={24}
                trailingAction={trailingAction}
            >
                <Text className={styles.callToActionContent}>{text}</Text>
            </CallToAction>
        </div>
    );
};

export default SelectionGiftPrompt;
